<script>
export default {
  name: "AppFooter",
  props: {
    links: { type: Array, default: () => [] },
    push: {type: Boolean, default: true },
    secondaryLogo: { type: Object, default: null },
  },
  computed: {
    appVersion() {
      return this.$store.getters["App/appVersion"]
    },
    secondaryLogoAlt() {
      return this.secondaryLogo?.alt
    },
    secondaryLogoSrc() {
      let path = null
      if (this.secondaryLogo?.src) {
        try {
          path = require(`@/assets/${this.secondaryLogo.src}`)
        } catch (error) {
          console.error(error)
        }
      }
      return path
    },
  },
  created() {
    if (process.env.PACKAGE_VERSION !== this.$store.getters["App/appVersion"]) {
      this.$store.dispatch("App/refreshVersion")
    }
  },
}
</script>

<template>
  <div>
    <b-row
      id="AppFooter"
      align-v="center"
      no-gutters
    >
      <b-col cols="3">
        <div class="logoWrapper ml-3">
          <img
            alt="ARM logo"
            class="img-responsive"
            src="../assets/ARM_Logo_White.svg"
          />
          <div class="version text-center">
            Version {{appVersion}}
          </div>
        </div>
      </b-col>
      <b-col cols="6">
        <b-row>
          <b-col
            v-for="(link, index) in links"
            :key="index"
            cols="6"
          >
            <a
              :href="link.url"
              target="_blank"
            >
              {{ link.text }}
            </a>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3">
        <b-img
          v-if="secondaryLogoSrc"
          :alt="secondaryLogoAlt"
          :src="secondaryLogoSrc"
          class="secondaryLogo mr-3"
          thumbnail
          right
        />
      </b-col>
    </b-row>
  </div>
</template>

<style>
#AppFooter {
  width: 100%;
  height: 112px;
  background-color: #194173;
  border-top: 6px solid #00bd70;
}
#AppFooter .logoWrapper {
  width: 200px;
}
#AppFooter .secondaryLogo {
  max-height: 94px;
}
#AppFooter .version {
  color: #fff;
}
#AppFooter a {
  color: white;
}
</style>
